module.exports = __webpack_public_path__ + "static/assets/f3991939a8429a0887db17199f4f8084.svg";